import React, { useContext, useState } from 'react'
import styles from "./Model.module.css"
import web from "../../assets/svg/web.svg"
import penpaper from "../../assets/svg/penpep.svg"
import mobile from "../../assets/svg/mobile.svg"
import web3 from "../../assets/svg/web3.svg"
import seting from "../../assets/svg/setting.svg"
import AiTool from "../../assets/svg/AiTool.svg"
import { AiOutlineClose } from "react-icons/ai";
import GlobalStorage from '../../Storage/ContextProvider'
function Model() {
    const { showModel, setShowModel, which, setWhich } = useContext(GlobalStorage)
    //console.log("model=>", showModel, which)
    const [position, setPostion] = useState({ x: 0, y: 0 })
    const getcordinates = (e) => {
        setPostion({ ...position, x: e.pageX - e.currentTarget.offsetLeft, y: e.clientY - e.currentTarget.offsetTop })
        //console.log(e)
    }
    //console.log(position)
    return (
        <div onMouseMove={getcordinates} onClick={() => setShowModel(false)} className={`${styles.modelContainer} ${showModel ? styles.showModel : ""}`}>
            {/* <AiOutlineClose onClick={() =>setShowModel(false)} /> */}
            <p style={{ left: position.x, top: position.y }} className={styles.tooltip_custome}>Click anywhere to close the dialog </p>
            {which == 'web' && <div onMouseMove={getcordinates} onClick={(e) => e.stopPropagation()} className={styles.modeBody}>

                <h1>webサイト制作</h1>
                <div className={styles.modelInnerBody}>
                    <img src={penpaper} alt="" />
                    <p>ホームページやサービスページの作成は、一見簡単そうに見えて簡単ではありません。どういったユーザーをターゲトにするのか、何を目的にするのか。そういった重要な情報をもとに、デザインだけでなく、ウェブページの裏に仕込む仕組みが大きく変わってきます。そのため、繰り返しヒアリングさせていただき、御社に最適なランディングページやホームページを制作させていただきます。デザインにももちんこだわっています。</p>
                </div>
            </div>}
            {which == 'web2' && <div onClick={(e) => e.stopPropagation()} className={styles.modeBody}>

                <h1>webシステム開発</h1>
                <div className={styles.modelInnerBody}>
                    <img src={penpaper} alt="" />
                    <p>セキュリティテストの目的は、Webアプリケーションの脆弱性を発見し、開発者がアプリケーションからこれらの脆弱性を取り除き、Webアプリケーションとデータを不正な行為から安全にすることです。
                        セイキュリティに関しても、デバイスの関連してくる複雑なシステムでも開発可能です。ご相談ください。</p>
                </div>
            </div>}
            {which == 'web3' && <div onClick={(e) => e.stopPropagation()} className={styles.modeBody}>

                <h1>web3.0</h1>
                <div className={styles.modelInnerBody}>
                    <img src={web3} alt="" />
                    <p>先端技術を活用した開発も可能です。web3やそれに関連したブロックチェーンに関する技術も弊社は保有します。お気軽にご相談ください。 <br /> Web3のライブラリは、ブロックチェーンとのインターフェイスを容易にし、トランザクションを行い、スマートコントラクトと対話することを支援します。</p>
                </div>
            </div>}
            {which == 'mobile' && <div onClick={(e) => e.stopPropagation()} className={styles.modeBody}>

                <h1>アプリ開発</h1>
                <div className={styles.modelInnerBody}>
                    <img src={mobile} alt="" />
                    <p>私たちは、スタートアップ、中小企業、大企業向けのトップクラスのiOSアプリを設計および開発しています。また、アンドロイド向けのアプリ開発に関しても、経験の豊富なエンジニアがサポートさせていただきます。</p>
                </div>
            </div>}
            {which == 'busWeb' && <div onClick={(e) => e.stopPropagation()} className={styles.modeBody}>

                <h1>海外進出サポート</h1>
                <div className={styles.modelInnerBody}>
                    <img src={web} alt="" />
                    <p>SHARVIL Business Groupのもつ世界中のネットワークは顧客の新たな事業領域の開発、世界市場への進出をサポートできます。 <br /> <br /> 幅広い領域にて、多くの選択肢の中から最適なソルーションをご提供させていただきます。
                    </p>
                </div>
            </div>}
            {which == 'busPen' && <div onClick={(e) => e.stopPropagation()} className={styles.modeBody}>

                <h1>貿易サポート</h1>
                <div className={styles.modelInnerBody}>
                    <img src={penpaper} alt="" />
                    <p>SHARVIL Business Groupのもつ世界中のネットワークは顧客の新たな事業領域の開発、世界市場への進出をサポートできます。 <br /> <br /> さまざまな商材の輸入,輸出に関してお手伝いさせていただくことが可能です。

                    </p>
                </div>
            </div>}
            {which == 'settings' && <div onClick={(e) => e.stopPropagation()} className={styles.modeBody}>

                <h1>事業開発</h1>
                <div className={styles.modelInnerBody}>
                    <img src={seting} alt="" />
                    <p>非常に多くの領域でビジネスを展開してきたこと、そして、世界中に弊社のチームが存在することから、さまざまな市場で、成功したチームがどのように考え、どのように行動したのか、それらの情報をもつのが弊社の強みの一つです。 <br /> <br /> それらを活用し、事業開発に関してもご相談していただけます。

                    </p>
                </div>
            </div>}
            {which == 'AIアルゴリズム開発' && <div onClick={(e) => e.stopPropagation()} className={styles.modeBody}>

                <h1>AIアルゴリズム開発</h1>
                <div className={styles.modelInnerBody}>
                    <img src={AiTool} alt="" />
                    <p>
                        AI領域での開発も得意にしております。ChatGPTの話題 <br /> ぶりをみてもわかりますが、AIが解決することのできる <br /> 問題は多くあります。現在の業務フローの自動化、システ <br /> ム内の問題、誤差のAIのアルゴリズムによる解決など、<br /> 実現することができるソリューションは多くあります。<br /> どのような問題でも、AIによって解決できる可能性があ <br /> ります。可能性の模索から並走させていただきます。

                    </p>
                </div>
            </div>}
        </div>
    )
}

export default Model